export default "__VITE_ASSET__68f5910c__"